<template>
  <section>
    <div
      v-if="data && data.length"
      class="grid gap-8 xl:gap-6 lg:grid-cols-2 xl:grid-cols-3 grid-cols-1"
    >
      <div v-for="d in data" :key="d.id">
        <router-link
          :to="{ name: 'UserCourseDetails', params: { id: d.course_id } }"
          v-if="d.entity_type == 2"
        >
          <!-- <CourseSessionListingCard :d="d" /> -->
          <Card :data="d" :isFavourite="false" :isCategory="false" :isRating="false"/>
        </router-link>
        <router-link
          :to="{ name: 'UserSessionDetails', params: { id: d.session_id } }"
          v-else
        >
          <!-- <CourseSessionListingCard :d="d" /> -->
          <Card :data="d" :isFavourite="false" :isCategory="false" :isRating="false"/>
        </router-link>
      </div>
    </div>
    <div
      class="flex flex-col justify-center items-center text-xl text-gray-700 mt-4 space-y-8"
      v-else
    >
      <img
        :src="require(`@/assets/svg/completed-sessions-nodata.svg`)"
        alt="..."
        class="w-72 h-56"
      />
      <div class="flex flex-col text-lg justify-center text-center">
        <span>You don’t seem to have any completed classes</span>
        <span>All classes that you attend will be available here.</span>
      </div>
    </div>
  </section>
</template>

<script>
//import CourseSessionListingCard from "@/components/CourseSessionListingCard.vue";
import Card from "@/components/card/Card.vue";
export default {
  name: "CompletedSessionList",
  components: {
    //CourseSessionListingCard,
    Card,
  },
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>